<template>
	<!-- Team start -->
	<section class="section" id="services" v-on:click="closeItems">
		<div class="container">
			<div class="row justify-content-center mb-5">
				<div class="col-lg-12">
					<h4 class="text-uppercase mb-3 pb-1">네이버쇼핑 순위</h4>
				</div>
				<!--<div class="col-lg-12">
					<div class="card mt-4 rounded border-0 shadow overflow-hidden">
						<div class="card-body">
							<div>현재 네이버 정책 강화로 새 상품추가 기능이 지원되지 않습니다.</div>
							<div>불편을 드려 죄송합니다.</div>
							<div>기존에 상품을 추가하신 분들은 기존 방식대로 사용할 수 있습니다.</div>
							<div>빠른 시일 내에 더 좋은 모습으로 찾아뵙겠습니다.</div>
						</div>
					</div>
				</div>-->

				<div class="col-lg-9">
					<div class="card mt-4 rounded border-0 shadow overflow-hidden">
						<div class="card-body">
							<h4 class="text-uppercase mb-3 pb-1 text-center">상품정보</h4>
							<div class="rank-container mb-3">
								<input v-model="productUrl" class="rank-item-add form-control" type="text" placeholder="스마트스토어 상품주소를 입력 후 추가해주세요." />
								<button v-on:click="addProduct" type="button" class="rank-item-add btn btn-outline-primary btn-sm">추가</button>
							</div>
							<div class="rank-container mb-3">
								<div class="input-group" id="search-input-group">
									<span class="input-group-text bg-white rank-item-search" id="basic-addon1" @mouseup="searchItemName()">
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
											<path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"></path>
										</svg>
									</span>
									<input
										autocomplete="off"
										id="searchItem"
										v-model="searchItem"
										@keyup="searchItemName($event)"
										@mouseup="searchItemName()"
										type="text"
										class="rank-item-search bg-white form-control"
										placeholder="추가한 상품을 검색해주세요."
										aria-label="Input group example"
										aria-describedby="basic-addon1"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="col-lg-3">
					<div class="card mt-4 rounded text-center border-0 shadow overflow-hidden">
						<div class="card-body">
							<h4 class="text-uppercase mb-3 pb-1">키워드</h4>
							<div class="rank-container mb-3">
								<textarea id="contentTextArea" type="text" class="rank-keyword form-control" v-model="searchKeyword" placeholder=""> </textarea>
								<button v-on:click="addKeywords" type="button" class="rank-keyword btn btn-outline-primary btn-sm">추가</button>
							</div>
						</div>
					</div>
				</div>

				<div class="col-lg-12" v-show="nokey">
					<div class="card mt-4 rounded text-center border-0 shadow overflow-hidden">
						<div class="card-body px-4 py-5" v-show="nokey">
							<div class="rank-container">
								<h4 class="text-uppercase mb-3 pb-1 text-center width100">키워드 별 순위정보</h4>
							</div>

							<div class="rank-reverse-container mb-3" id="yeskeyword">
								<button v-on:click="removeProduct" type="button" class="rank-reverse-item btn btn-primary btn-sm">상품삭제</button>
								<h6 v-on:click="goProduct" title="상품 페이지 열기" class="rank-reverse-item text-uppercase alert alert-primary">{{ this.selectedMallProduct }}</h6>
							</div>
							<div>
								<ul>
									<h6 class="text-uppercase m-5 pb-1">키워드를 추가해주세요.</h6>
								</ul>
							</div>
						</div>
					</div>
				</div>

				<div class="col-lg-12" v-show="yeskey">
					<div class="card mt-4 rounded text-center border-0 shadow overflow-hidden">
						<div class="card-body px-4 py-5">
							<div class="rank-container">
								<h4 class="text-uppercase mb-3 pb-1 text-center width100">키워드 별 순위정보</h4>
							</div>

							<div class="rank-reverse-container mb-3" id="yeskeyword">
								<button v-on:click="getRank" type="button" class="rank-reverse-item btn btn-outline-primary btn-sm">조회하기</button>
								<h6 v-on:click="goProduct" title="상품 페이지 열기" class="rank-reverse-item text-uppercase alert alert-primary">{{ this.selectedMallProduct }}</h6>
							</div>
							<div id="table-container" ref="divTable">
								<div class="table-item">
									<table class="table table-striped rank-table" id="rank-table" style="display: none">
										<thead>
											<tr>
												<th><input class="form-check-input select-all" type="checkbox" /></th>
												<th>키워드</th>
												<th>검색량</th>
												<th v-for="dateth in datetr" :key="dateth.val">{{ dateth }}</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="item in items" :key="item.keyword">
												<td><input class="form-check-input" type="checkbox" name="checkbox" :value="item.keyword" /></td>

												<td>{{ item.keyword }}</td>
												<td>
													<div class="search-count">{{ item.searchCount }}</div>
												</td>

												<td v-for="ranktd in item" :key="ranktd.val">
													<div class="jcc-df">
														<div>{{ ranktd.rank }}</div>
														<div class="rankgap" :class="{ 'text-primary': ranktd.gap < 0, 'text-danger': ranktd.gap > 0 }">{{ ranktd.icon }}</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="d-flex flex-row-reverse mb-3">
								<button v-on:click="removeProduct" type="button" class="p-2 btn btn-primary btn-sm m-2">상품삭제</button>
								<button v-on:click="removeKeywords" type="button" class="p-2 btn btn-primary btn-sm m-2">키워드삭제</button>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-12">
					<h4 class="text-uppercase pt-5">네이버쇼핑 순위확인 방법</h4>
					<div class="card rounded border-0 shadow overflow-hidden">
						<div class="tab-content" id="myTabContent">
							<div class="tab-pane fade show active px-4 py-5" id="common" role="tabpanel" aria-labelledby="common-tab">
								<div class="mb-3 pb-1">
									<iframe
										width="560"
										height="315"
										src="https://www.youtube.com/embed/GF0w_HfhAEk"
										title="YouTube video player"
										frameborder="0"
										allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
										allowfullscreen
									></iframe>
								</div>

								<h4 class="text-uppercase mb-3 pb-1">네이버쇼핑 순위란?</h4>
								<ul>
									<li class="text-muted mb-5">네이버쇼핑에서 특정 키워드에 대한 스마트스토어 상품의 순위를 확인할 수 있는 서비스 입니다.</li>
								</ul>
								<h4 class="text-uppercase mb-3 pb-1">조회방법</h4>
								<ol>
									<li class="text-muted mb-2">원하는 스마트스토어 상품 주소를 입력 후 추가해주세요.</li>
									<li class="text-muted mb-2">원하는 키워드를 추가해주세요.</li>
									<li class="text-muted mb-5">조회하기를 클릭해주세요.</li>
								</ol>
								<h4 class="text-uppercase mb-3 pb-1">유의사항</h4>
								<ul>
									<li class="text-muted mb-2">스마트스토어 상품만 등록 및 조회 가능합니다.</li>
									<li class="text-muted mb-2">순위가 500위 안에 상품이 없는 경우 … 으로 표시됩니다.</li>
									<li class="text-muted mb-2">가격비교 상품으로 묶여있는 경우 순위가 표시되지 않습니다.</li>
									<li class="text-muted mb-2">순위는 모바일을 기준으로 확인합니다. PC 순위의 경우 차이가 있을 수 있습니다.</li>
									<li class="text-muted mb-2">등록 가능한 상품수는 최대 30개, 키워드는 최대 100개 까지 등록 가능합니다.</li>
									<li class="text-muted mb-2">3개월 이상 미접속시 자동조회를 하지 않습니다.</li>
									<li class="text-muted mb-5">서버 상태에 따라 상품 추가 시 즉시 상품명을 확인하기 어려울 수 있습니다.</li>
								</ul>
								<h4 class="text-uppercase mb-3 pb-1">더 궁금한 것이 있습니다.</h4>
								<ul>
									<li class="text-muted mb-2">네이버톡톡 또는 채널톡으로 문의해주세요.</li>
									<li class="text-muted mb-2">문의 가능 시간 : 평일 11:00~17:00</li>
								</ul>
							</div>
						</div>
					</div>
				</div>

				<div class="rank-container position-absolute font14" id="searchedTitles" v-show="isst">
					<div class="list-group width100">
						<a v-on:click="selectProduct" v-for="product in searchedProducts" :key="product.productId" v-bind:value="product.productId" :selected="false" class="list-group-item list-group-item-action cursor-pointer">
							<b>[{{ product.mallName }}]</b> {{ product.productTitle }}
						</a>
						<button id="selectProductMore" v-on:click="selectProductMore" class="list-group-item list-group-item-action cursor-pointer text-center">더 보기 ∨</button>
					</div>
				</div>

				<div>
					<!-- <center style="margin-top:20px;"><iframe width="800" height="600" src="https://www.youtube.com/embed/chKcte7A1P8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></center> -->
				</div>
			</div>
		</div>
		<!-- end container -->
	</section>
</template>

<script>
import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.xsrfCookieName = "XSRF-TOKEN";
axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
// import 'datatables.net-bs5'
import $ from "jquery";
// import jquery from '../../../js/jquery-3.5.1.js';
import dataTables from "../../../js/jquery.dataTables.min.js";
import fixedColumns from "../../../js/dataTables.fixedColumns.min.js";

import "../../../css/jquery.dataTables.min.css";
import "../../../css/fixedColumns.dataTables.min.css";

export default {
	data() {
		return {
			productUrl: "",
			productList: [],
			optionMalls: [],
			optionProducts: [],
			searchedProducts: [],
			searchItem: "",
			searchKeyword: "",
			selectedMall: "",
			selectedProduct: "",
			selectedMallProduct: "",
			limit: "100건",
			ecmdata: "",
			token: "",
			isst: false,
			items: [],
			datetr: [],
			table: "",
			nokey: false,
			yeskey: false,
			local: ""
		};
	},
	beforeMount() {
		axios
			.get(this.local + "/rank/getProducts")
			.then(response => {
				this.spinnerEnd();
				if (response.status == 200) {
					this.productList = response.data.productList;
					for (var i = 0; i < this.productList.length; i++) {
						let product = this.productList[i];
						let mall = {
							mallId: product.mallId,
							mallName: product.mallName
						};
						if (!this.containsObject(mall, this.optionMalls)) {
							this.optionMalls.push(mall);
						}
					}

					this.productList.sort(function(a, b) {
						let atitle = "[" + a.mallName + "] " + a.productTitle;
						let btitle = "[" + b.mallName + "] " + b.productTitle;
						return atitle < btitle ? -1 : atitle > btitle ? 1 : 0;
					});
				}
			})
			.catch(error => {
				this.invalidSession(error);
			});
	},
	mounted() {
		window.addEventListener("resize", this.closeItemsResize);
	},
	methods: {
		invalidSession: function(error) {
			console.info(error);
			this.spinnerEnd();
			if (error && error.response && error.response.status && error.response.status == 401) {
				swal("세션이 만료되었습니다. 다시 로그인 해주세요.").then(value => {
					this.$router.push("/signin");
				});
			} else {
				swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요.", { icon: "info" });
			}
		},
		addProduct: function(e) {
			e.preventDefault();

			this.errors = [];

			if (!this.productUrl) {
				this.errors.push("상품주소를 입력해주세요.");
			} else if (this.productUrl.indexOf(".naver.com/") == -1) {
				this.errors.push("스마트스토어 상품주소만 입력 가능합니다.");
			}

			if (this.errors.length) {
				swal(this.errors[0]);
				return true;
			} else {
				var form = new FormData();
				form.append("productUrl", this.productUrl);
				this.loginSuccess = false;
				this.spinnerStart();
				this.items = [];
				axios
					.post(this.local + "/rank/addProduct", form)
					.then(response => {
						this.spinnerEnd();

						if (response.status == 200) {
							var code = response.data.code;
							var rankProduct = response.data.rankProduct;
							if (code == 0) {
								swal("상품이 존재하지 않습니다.", { icon: "info" });
							} else if (code == 2) {
								swal("이미 추가된 상품입니다.", { icon: "info" });
							} else if (code == 30) {
								swal("최대 상품수(30개)를 초과하였습니다. ", { icon: "info" });
							} else if (code == 1) {
								this.productList.push(rankProduct);
								this.selectedProduct = rankProduct;
								let title = "[" + this.selectedProduct.mallName + "] " + this.selectedProduct.productTitle;
								this.selectedMallProduct = title;
								this.searchItem = title;

								if (this.yeskey) {
									document.getElementById("rank-table-cp_wrapper").remove();
								}
								this.nokey = true;
								this.yeskey = false;

								this.items = [];
								this.datetr = [];

								swal("상품이 추가되었습니다.");

								this.nokey = true;
							}
							this.productUrl = "";
						} else {
							swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요. -2", { icon: "info" });
						}
					})
					.catch(error => {
						this.invalidSession(error);
					});
			}
		},
		searchItemName: function(event) {
			if (event) {
				let searchItem = event.target.value;
				this.searchedProducts = [];

				for (var i = 0; i < this.productList.length; i++) {
					let product = this.productList[i];
					let title = "[" + product.mallName + "] " + product.productTitle;
					product.title = title;
					if (title.toLowerCase().includes(searchItem.toLowerCase()) || searchItem.trim() == "") {
						this.searchedProducts.push(product);
					}
					if (this.searchedProducts.length > 8) {
						break;
					}
				}
			} else {
				this.searchItem = "";
				this.searchedProducts = [];
				for (var i = 0; i < this.productList.length; i++) {
					let product = this.productList[i];
					let title = "[" + product.mallName + "] " + product.productTitle;
					product.title = title;
					this.searchedProducts.push(product);
					if (this.searchedProducts.length > 8) {
						break;
					}
				}
			}

			let sigel = document.getElementById("search-input-group");
			let top = window.pageYOffset + sigel.getBoundingClientRect().top;
			let left = window.pageXOffset + sigel.getBoundingClientRect().left;

			let sk = document.getElementById("searchItem");
			let st = document.getElementById("searchedTitles");

			st.style.top = top + 40 + "px";
			st.style.left = left + 38 + "px";
			st.style.width = sk.offsetWidth + "px";
			st.style.padding = "0px";

			this.isst = true;
		},
		goProduct: function() {
			if (this.selectedProduct && this.selectedProduct.productId) {
				let url = this.selectedProduct.productUrl;
				window.open(url, "_blank");
			} else {
				swal("상품을 검색 후 선택해주세요.");
			}
		},
		removeProduct: function() {
			if (this.selectedProduct && this.selectedProduct.productId) {
				swal({
					title: "정말로 삭제하시겠습니까?",
					text: "상품에 포함된 모든 키워드 및 순위기록도 함께 삭제됩니다.",
					icon: "warning",
					buttons: true,
					dangerMode: true
				}).then(willDelete => {
					if (willDelete) {
						var form = new FormData();
						form.append("productId", this.selectedProduct.productId);
						this.spinnerStart();
						this.items = [];
						axios
							.post(this.local + "/rank/removeProduct", form)
							.then(response => {
								this.spinnerEnd();
								if (response.status == 200 && response.data.code == 1) {
									for (var i = this.productList.length - 1; i >= 0; i--) {
										let product = this.productList[i];
										if (product.productId == this.selectedProduct.productId) {
											this.productList.splice(i, 1);
											break;
										}
									}
									this.searchItem = "";
									this.searchKeyword = "";
									this.selectedProduct = "";
									this.selectedMallProduct = "";
									this.items = [];
									this.datetr = [];

									swal("상품이 삭제되었습니다.").then(value => {
										this.nokey = false;
										this.yeskey = false;
									});
								} else {
									swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요. -2", { icon: "info" });
								}
							})
							.catch(error => {
								this.invalidSession(error);
							});
					}
				});
			} else {
				swal("상품을 검색 후 선택해주세요.");
			}
		},
		closeItems: function(e) {
			if (e && (e.target.id == "searchItem" || e.target.id == "search-input-group" || e.target.id == "selectProductMore" || e.target.id == "basic-addon1" || e.target.tagName == "svg" || e.target.tagName == "path")) {
				return;
			} else if (this.isst) {
				this.isst = false;
			}
		},
		closeItemsResize: function() {
			this.isst = false;

			$(document).ready(function() {
				let width = $("#table-container").width();
				$(".dataTables_wrapper").css("width", width);
			});
		},
		selectProduct: function(event) {
			let productId = event.target.getAttribute("value");

			for (var i = 0; i < this.productList.length; i++) {
				let product = this.productList[i];
				if (product.productId == productId) {
					this.selectedProduct = product;
					let title = "[" + this.selectedProduct.mallName + "] " + this.selectedProduct.productTitle;
					this.selectedMallProduct = title;
					this.searchItem = title;
				}
			}
			this.spinnerStart();

			var form = new FormData();
			form.append("productId", productId);
			this.loginSuccess = false;

			axios
				.post(this.local + "/rank/getRankSimple", form)
				.then(response => {
					if (response.status == 200) {
						let code = response.data.code;
						this.selectedProduct.productTitle = response.data.title;
						this.selectedProduct.mallName = response.data.mall;

						let title = "[" + this.selectedProduct.mallName + "] " + this.selectedProduct.productTitle;
						this.selectedMallProduct = title;
						this.searchItem = title;

						for (var i = 0; i < this.productList.length; i++) {
							let product = this.productList[i];
							if (product.productId == this.selectedProduct.productId) {
								product.mallName = this.selectedProduct.mallName;
								product.productTitle = this.selectedProduct.productTitle;
								break;
							}
						}

						if (document.getElementById("rank-table-cp_wrapper")) {
							document.getElementById("rank-table-cp_wrapper").remove();
						}
						if (code == 1) {
							let rank = response.data.rank;
							let hasKeyword = false;
							for (var key in rank) {
								hasKeyword = true;
								break;
							}
							if (hasKeyword) {
								this.nokey = false;
								this.yeskey = true;

								this.showRank(rank);
							} else {
								this.nokey = true;
								this.yeskey = false;
							}
						} else if (code == -1) {
							swal({
								title: "상품을 삭제하시겠습니까?",
								text: "스마트스토어에 해당 상품이 존재하지 않습니다.",
								icon: "warning",
								buttons: true,
								dangerMode: true
							}).then(willDelete => {
								if (willDelete) {
									var form = new FormData();
									form.append("productId", this.selectedProduct.productId);
									this.spinnerStart();
									this.items = [];
									axios
										.post(this.local + "/rank/removeProduct", form)
										.then(response => {
											this.spinnerEnd();
											if (response.status == 200 && response.data.code == 1) {
												for (var i = this.productList.length - 1; i >= 0; i--) {
													let product = this.productList[i];
													if (product.productId == this.selectedProduct.productId) {
														this.productList.splice(i, 1);
														break;
													}
												}
												this.searchItem = "";
												this.searchKeyword = "";
												this.selectedProduct = "";
												this.selectedMallProduct = "";
												this.items = [];
												this.datetr = [];
												swal("상품이 삭제되었습니다.");
											} else {
												swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요. -2", { icon: "info" });
											}
										})
										.catch(error => {
											this.invalidSession(error);
										});
								}
							});
						} else {
							swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요. -1", { icon: "info" });
						}
					} else {
						swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요. -2", { icon: "info" });
					}
					this.spinnerEnd();
				})
				.catch(error => {
					this.invalidSession(error);
				});
		},
		selectProductMore: function() {
			this.searchedProducts = [];
			for (var i = 0; i < this.productList.length; i++) {
				let product = this.productList[i];
				let title = "[" + product.mallName + "] " + product.productTitle;
				product.title = title;
				if (title.toLowerCase().includes(this.searchItem.toLowerCase()) || this.searchItem.trim() == "") {
					this.searchedProducts.push(product);
				}
			}

			let sigel = document.getElementById("search-input-group");
			let top = window.pageYOffset + sigel.getBoundingClientRect().top;
			let left = window.pageXOffset + sigel.getBoundingClientRect().left;

			let sk = document.getElementById("searchItem");
			let st = document.getElementById("searchedTitles");

			st.style.top = top + 40 + "px";
			st.style.left = left + 38 + "px";
			st.style.width = sk.offsetWidth + "px";
			st.style.padding = "0px";

			this.isst = true;
		},
		getRank: function() {
			this.errors = [];

			if (this.items.length == 0) {
				this.errors.push("먼저 키워드를 추가해주세요.");
				swal(this.errors[0]).then(function() {
					document.getElementById("contentTextArea").focus();
				});
				return true;
			}
			this.spinnerStart();

			let productId = this.selectedProduct.productId;

			var form = new FormData();
			form.append("productId", productId);
			this.loginSuccess = false;

			axios
				.post(this.local + "/rank/getRank", form)
				.then(response => {
					if (response.status == 200) {
						let code = response.data.code;
						this.selectedProduct.productTitle = response.data.title;
						this.selectedProduct.mallName = response.data.mall;
						let title = "[" + this.selectedProduct.mallName + "] " + this.selectedProduct.productTitle;
						this.selectedMallProduct = title;
						this.searchItem = title;

						for (var i = 0; i < this.productList.length; i++) {
							let product = this.productList[i];

							if (product.productId == this.selectedProduct.productId) {
								product.mallName = this.selectedProduct.mallName;
								product.productTitle = this.selectedProduct.productTitle;
								break;
							}
						}

						if (code == 1) {
							if (document.getElementById("rank-table-cp_wrapper")) {
								document.getElementById("rank-table-cp_wrapper").remove();
							}
							this.showRank(response.data.rank);
						} else if (code == -1) {
							swal("상품이 존재하지 않아 순위를 조회할 수 없습니다.", { icon: "info" });
							swal({
								title: "상품이 존재하지 않습니다.",
								text: "해당 상품을 삭제하시겠습니까?",
								buttons: true,
								dangerMode: true
							}).then(willDelete => {
								if (willDelete) {
									swal("상품을 삭제했습니다.", {
										icon: "success"
									});
								} else {
									swal("상품삭제취소");
								}
							});
						} else {
							swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요. -1", { icon: "info" });
						}
					} else {
						swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요. -2", { icon: "info" });
					}
					// this.spinnerEnd()
					this.spinnerEnd();
				})
				.catch(error => {
					this.invalidSession(error);
				});
		},
		addKeywords: function(e) {
			e.preventDefault();
			this.errors = [];
			if (!this.selectedProduct) {
				this.errors.push("상품을 선택해주세요.");
			}

			if (!this.searchKeyword) {
				this.errors.push("키워드를 입력해주세요.");
			}

			if (this.errors.length) {
				swal(this.errors[0]);
				return true;
			} else {
				var form = new FormData();
				form.append("productId", this.selectedProduct.productId);
				form.append("keywords", this.searchKeyword);
				this.loginSuccess = false;
				this.spinnerStart();
				axios
					.post(this.local + "/rank/addKeywords", form)
					.then(response => {
						this.spinnerEnd();

						if (response.status == 200) {
							let code = response.data.code;
							if (code == 2) {
								swal("키워드를 입력해주세요.", { icon: "info" });
							} else if (code == 3) {
								swal("계정당 최대 100개까지 추가 가능합니다.", { icon: "info" });
							} else if (code == 4) {
								swal("키워드를 추가할 수 없습니다.\n 특수문자가 포함되어 있거나, \n이미 추가된 키워드입니다.", { icon: "info" });
							} else if (code == 1) {
								let keywordArray = response.data.keywordList;
								for (var i = 0; i < keywordArray.length; i++) {
									let keyword = keywordArray[i].keyword;
									if (!keyword || keyword == "" || keyword.trim() == "") {
										continue;
									}
									let item = [];
									item.keyword = keyword.trim();
									item.searchCount = 0;
									if (this.datetr.length == 0) {
										let today = new Date();
										let date = today.getMonth() + 1 + "월 " + today.getDate() + "일 ";
										this.datetr.push(date);

										let ranktd = {
											rank: "…",
											icon: "",
											gap: 0
										};
										item.push(ranktd);
									} else {
										for (var j = 0; j < this.datetr.length; j++) {
											let ranktd = {
												rank: "…",
												icon: "",
												gap: 0
											};
											item.push(ranktd);
										}
									}

									this.items.push(item);
								}

								if (document.getElementById("rank-table-cp_wrapper")) {
									document.getElementById("rank-table-cp_wrapper").remove();
								}

								this.nokey = false;
								this.yeskey = true;
								this.drawDataTable();

								swal("키워드를 추가했습니다.", { icon: "success" });
							} else {
								swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요. -1", { icon: "info" });
							}
						} else {
							swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요. -2", { icon: "info" });
						}
						this.searchKeyword = "";
					})
					.catch(error => {
						this.invalidSession(error);
					});
			}
		},
		removeKeywords: function() {
			var selectedKeywordEl = document.querySelectorAll("input[name=checkbox]:checked");
			let selectedKeywords = [];
			for (var i = 0; i < selectedKeywordEl.length; i++) {
				if (selectedKeywordEl[i]) {
					let selectedKeyword = selectedKeywordEl[i].value;
					selectedKeywords.push(selectedKeyword);
				}
			}

			this.errors = [];
			if (!selectedKeywords || selectedKeywords.length == 0) {
				this.errors.push("키워드를 선택해주세요.");
			}
			if (this.errors.length) {
				swal(this.errors[0]);
				return true;
			} else {
				swal({
					title: "정말로 삭제하시겠습니까?",
					text: "선택한 키워드 및 순위기록도 함께 삭제됩니다.",
					icon: "warning",
					buttons: true,
					dangerMode: true
				}).then(willDelete => {
					if (willDelete) {
						var form = new FormData();
						form.append("productId", this.selectedProduct.productId);
						form.append("keywords", selectedKeywords);
						this.loginSuccess = false;
						this.spinnerStart();
						axios
							.post(this.local + "/rank/removeKeywords", form)
							.then(response => {
								this.spinnerEnd();
								if (response.status == 200) {
									let code = response.data.code;
									if (code == 1) {
										for (var i = 0; i < this.items.length; i++) {
											let keyword = this.items[i].keyword;

											if (selectedKeywords.includes(keyword)) {
												this.items.splice(i, 1);
												i--;
											}
										}
										if (document.getElementById("rank-table-cp_wrapper")) {
											document.getElementById("rank-table-cp_wrapper").remove();
										}
										if (this.items.length > 0) {
											this.nokey = false;
											this.yeskey = true;
											this.drawDataTable();

											swal("키워드를 삭제했습니다.", { icon: "success" });
										} else {
											this.nokey = true;
											this.yeskey = false;
										}
									} else {
										swal("키워드 삭제가 실패했습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요. -1", { icon: "info" });
									}
								} else {
									swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요. -2", { icon: "info" });
								}
							})
							.catch(error => {
								this.invalidSession(error);
							});
					}
				});
			}
		},
		showRank: function(rank) {
			let maxdate = 0;
			this.items = [];
			this.datetr = [];

			let entries = Object.entries(rank);
			entries.sort(([, a], [, b]) => b[0] - a[0]);
			let sortedRank = Object.fromEntries(entries);

			for (var key in sortedRank) {
				let rankList = sortedRank[key];
				let ranktr = [];
				let item = [];

				const option = {
					maximumFractionDigits: 4
				};
				const searchCount = rankList[0].toLocaleString("ko-KR", option);

				item.keyword = key;
				item.searchCount = searchCount;

				if (rankList.length - 1 > maxdate) {
					maxdate = rankList.length - 1;
				}

				const twoYearsAgo = new Date();
				twoYearsAgo.setFullYear(twoYearsAgo.getFullYear() - 2);

				let today = new Date();
				today.setDate(today.getDate() + 1);
				for (var i = 1; i < rankList.length; i++) {
					today.setDate(today.getDate() - 1);
					if (today < twoYearsAgo) {
						break;
					} else if (i > 90 && today.getDay() !== 1) {
						continue;
					}

					let rankday = rankList[i];
					let gapicon = "";
					let gap = 0;

					if (i < rankList.length - 1) {
						let rankdayprev = rankList[i + 1];
						if (rankdayprev != 0) {
							gap = rankdayprev - rankday;
							if (gap > 0) {
								gapicon = "▲" + gap;
							} else if (gap < 0) {
								gapicon = "▼" + gap * -1;
							} else {
								gapicon = "-";
							}
						}
					}

					let ranktd = {
						rank: "…",
						icon: "",
						gap: 0
					};
					if (rankday != 0) {
						ranktd = {
							rank: rankday + "위",
							icon: gapicon,
							gap: gap
						};
					}
					item.push(ranktd);
				}
				if (maxdate < 9) {
					let ranktd = {
						rank: "…",
						icon: "",
						gap: 0
					};
					item.push(ranktd);
				}
				// console.log("td size " + item.length);
				this.items.push(item);
			}

			let today = new Date();
			const thisYear = today.getFullYear();
			today.setDate(today.getDate() + 1);
			for (var i = 0; i < maxdate; i++) {
				today.setDate(today.getDate() - 1);
				let date = "";
				let newYear = today.getFullYear();
				if (thisYear > newYear) {
					date = (newYear % 100) + "년" + (today.getMonth() + 1) + "월" + today.getDate() + "일";
				} else {
					date = today.getMonth() + 1 + "월 " + today.getDate() + "일 ";
				}

				if (i > 90 && today.getDay() !== 1) {
					continue;
				}
				this.datetr.push(date);

				if (this.datetr.length == this.items[0].length) {
					break;
				}
			}

			if (maxdate < 9) {
				this.datetr.push("");
			}
			// console.log("date size " + this.datetr.length);

			this.drawDataTable();
		},
		drawDataTable: function() {
			this.$nextTick(function() {
				const rankTable = document.getElementById("rank-table");
				const rankTableCp = rankTable.cloneNode(true);
				rankTableCp.id = "rank-table-cp";
				rankTable.after(rankTableCp);
				rankTableCp.style.display = "block";

				$(document).ready(function() {
					this.table = $("#rank-table-cp").DataTable({
						scrollY: "600px",
						scrollX: true,
						scrollCollapse: true,
						paging: false,
						searching: false,
						fixedHeader: false,
						fixedColumns: {
							left: 3,
							right: 0
						},
						columnDefs: [{ width: "100%", targets: -1 }],
						ordering: false,
						info: false
					});

					let width = $("#table-container").width();
					$(".dataTables_wrapper").css("width", width);

					// select keyword all or not
					$("#rank-table-cp_wrapper input.select-all").change(function() {
						let isAll = true;
						$("#rank-table-cp_wrapper input[name=checkbox]").each(function(index, item) {
							if ($(item).is(":checked") == false) {
								isAll = false;
								return;
							}
						});
						if (isAll) {
							$("#rank-table-cp_wrapper input[name=checkbox]").prop("checked", false);
						} else {
							$("#rank-table-cp_wrapper input[name=checkbox]").prop("checked", true);
						}
					});
					$("#rank-table-cp_wrapper input[name=checkbox]").change(function() {
						let isAll = true;
						$("#rank-table-cp_wrapper input[name=checkbox]").each(function(index, item) {
							if ($(item).is(":checked") == false) {
								isAll = false;
								return;
							}
						});
						if (isAll) {
							$("#rank-table-cp_wrapper input.select-all").prop("checked", true);
						} else {
							$("#rank-table-cp_wrapper input.select-all").prop("checked", false);
						}
					});
				});
			});
		},
		exceldown: function(e) {
			var data = [];
			var rows = document.querySelectorAll("table tr");

			for (var i = 0; i < rows.length; i++) {
				var row = [],
					cols = rows[i].querySelectorAll("td, th");
				for (var j = 0; j < cols.length; j++) {
					var text;
					if (j == 5 || j == 7) {
						text = '="' + cols[j].innerText + '"';
					} else {
						text = cols[j].innerText;
					}
					row.push(text);
				}
				data.push(row.join(","));
			}

			var filename = "순위.csv";
			var csv_file, download_link;
			csv_file = new Blob(["\ufeff" + data.join("\n")], { type: "text/csv;charset=utf-8;" });
			download_link = document.createElement("a");
			download_link.download = filename;
			download_link.href = window.URL.createObjectURL(csv_file);
			download_link.style.display = "none";
			document.body.appendChild(download_link);
			download_link.click();
		},
		validPassword: function(password) {
			var re = /(?=.*\d)(?=.*[a-z]).{8,16}/;
			return re.test(password);
		},
		containsObject: function(obj, list) {
			var i;
			for (i = 0; i < list.length; i++) {
				if (list[i].mallId === obj.mallId) {
					return true;
				}
			}

			return false;
		},
		getMatchClass: function(match) {
			// -1 : 요청 전
			// 0 : 불일치
			// 1 : 일치
			// 2 : 조회 실패
			if (match == 1) {
				return "pc4-pass";
			} else if (match == 0) {
				return "pc4-fail";
			} else if (match == 3) {
				return "pc4-empty";
			} else {
				return "";
			}
		},
		getMatchOX: function(match) {
			// -1 : 요청 전
			// 0 : 불일치
			// 1 : 일치
			// 2 : 조회 실패
			if (match == 1) {
				return "o";
			} else if (match == 0) {
				return "x";
			} else {
				return "";
			}
		},
		spinnerStart: function() {
			let preloader = document.getElementById("preloader");
			preloader.style.visibility = "visible";
			preloader.style.opacity = "0.5";
			preloader.style.background = "#000";
		},
		spinnerEnd: function() {
			let preloader = document.getElementById("preloader");
			preloader.style.visibility = "hidden";
			preloader.style.opacity = "0";
		}
	}
};
</script>
<style>
#table-container th,
#table-container td {
	white-space: nowrap;
	text-align: center;
}

#table-container td {
	border-bottom-color: #dee2e6;
}
#table-container th {
	border-bottom-color: #000000;
}

#table-container th:nth-child(3),
#table-container td:nth-child(3) {
	border-right-color: #dee2e6;
	border-right-width: 1px;
}
div.dataTables_wrapper {
	width: 1068px;
}

#searchedTitles {
	z-index: 10;
}

.rank-container {
	display: flex;
}
.rank-item-add:nth-child(1) {
	flex-grow: 1;
	margin-right: 10px;
}
.rank-item-add:nth-child(2) {
	flex-shrink: 0;
	width: 70px;
}

.rank-item-search:nth-child(1) {
	flex-shrink: 0;
	width: 40px;
}
.rank-item-search:nth-child(2) {
	flex-grow: 1;
}

.rank-item:nth-child(1) {
	flex-grow: 1;
	margin-right: 10px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.rank-item:nth-child(2) {
	flex-shrink: 0;
	width: 70px;
	margin-right: 10px;
}
.rank-item:nth-child(3) {
	flex-shrink: 0;
	width: 70px;
}

.rank-reverse-container {
	display: flex;
	flex-direction: row-reverse;
}

.rank-reverse-item:nth-child(1) {
	max-width: 170px;
}
.rank-reverse-item:nth-child(2) {
	flex-grow: 1;
	margin-right: 10px;
	padding: 0.5rem 0.5rem 0.5rem 18px;
	margin-bottom: 0;
	cursor: pointer;
}

.rank-keyword:nth-child(1) {
	flex-grow: 1;
	height: 96px;
	margin-right: 10px;
}
.rank-keyword:nth-child(2) {
	flex-shrink: 0;
	height: 96px;
	width: 70px;
}

#table-container {
	display: flex;
	flex-wrap: nowrap;
	justify-content: flex-start;
	width: 100%;
}

#table-container th,
#table-container td {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	min-width: 80px;
	max-width: 100%;
}

#table-container th:nth-child(1),
#table-container td:nth-child(1) {
	min-width: 35px;
	max-width: 35px;
}
#table-container th:nth-child(2),
#table-container td:nth-child(2) {
	min-width: 50px;
	max-width: 200px;
	text-align: left;
}
#table-container th:nth-child(3),
#table-container td:nth-child(3) {
	min-width: 50px;
	max-width: 100px;
	text-align: center;
}

.cursor-pointer {
	cursor: pointer;
}

.pf {
	width: 20px;
	height: 20px;
}
.pc4-pass {
	background-color: #e2efde;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}
.pc4-fail {
	background-color: #ec7b7b;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}
.pc4-empty {
	background-color: #eeeeee;
}
.pc4-pc4 {
	background-color: #eff1fc;
}
.pc4-title {
	font-weight: bold;
}
.step {
	width: 100%;
	border: 1px solid #000000;
	image-rendering: -webkit-optimize-contrast;
	transform: translateZ(0);
	backface-visibility: hidden;
	margin-bottom: 0.5rem !important;
}
.width100 {
	width: 100%;
}
.font14 {
	font-size: 14px;
}

.nav-item .nav-link.active {
	padding: 0.5rem 1rem;
}

.nav-item .nav-link {
	display: block;
	padding: 0.5rem 1rem 0.44rem;
	color: #0d6efd;
	text-decoration: none;
	background-color: #fff;
}

.jcc-df {
	justify-content: center;
	display: flex;
}

.table .search-count {
	text-align: right;
	padding-right: 15px;
}
.rankgap {
	margin: 3px 0 0 5px;
	font-size: 12px;
	min-width: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/main/Rank.vue